import { ErrorHandler, Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import ErrorHandling from './error-handler';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  public handleError(error: Error | HttpErrorResponse): void {
    ErrorHandling.handleError(error)
  }
}